import {collection, getDocs, getFirestore, orderBy, query, where} from "firebase/firestore";
import {useEffect, useState} from "react";
import {FaArrowAltCircleDown, FaArrowAltCircleUp} from "react-icons/fa";

export default function CelebTransactionHistory(props){
    const db=getFirestore();
    const [transactions,setTransactions]= useState([]);

    useEffect(async()=>{

        const q = query(collection(db, "transactions"), where("personId", "==",props.id),orderBy("createdAt"));
        var docs=await getDocs(q);

        var transactions=[];

        docs.forEach(element => {
            transactions.push(element.data());
        });

        setTransactions([...transactions]);

    },[]);

    return(
        <div className="h-96 w-full bg-white/50 overflow-scroll flex-col p-3 rounded">


            {
                transactions.map((transaction,index)=>{
                    return(

                        <div className="h-24 w-full bg-black mb-2 text-white flex justify-start items-center flex-row p-3  overflow-x-scoll">

                            <div className="w-10">
                                {
                                    transaction["from"]===props.id?
                                        <FaArrowAltCircleUp size={40}/>
                                        :
                                        <FaArrowAltCircleDown size={40}/>
                                }
                            </div>

                            <div className="pl-5 w-2/4">
                                {transaction["message"]}
                            </div>

                            <div className="pl-5 w-32 overflow-scroll">
                                {transaction["amount"]} GHS
                            </div>
                            <div className="pl-5 w-32">
                                {transaction["createdAt"].toDate().getDate().toString()}-{(transaction["createdAt"].toDate().getMonth()+1).toString()}-{transaction["createdAt"].toDate().getFullYear().toString()}
                            </div>

                        </div>

                    )
                })
            }


        </div>
    )
}